import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { RootState } from '../../../../store';
import { useSelector } from 'react-redux';
import { useMyAccount } from '../context/MyAccountContext';
import CareMapprButton from '../../../components/Button/CareMapprButton';
import { useClinicianProfile } from '../../../hooks';
import { updateClinicianProfileContact } from '../../../../api';
import Swal from 'sweetalert2';

const UserInfo: React.FC = () => {
  const { firstName, lastName } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const { clinicianProfileFields } = useClinicianProfile();

  const {
    onValidateUserInfoInput,
    userInfoErrors,
    isLoading,
    setIsLoading,
    userInfoFormData,
    userInfoOnInputChange,
  } = useMyAccount();

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    const isValid = onValidateUserInfoInput();
    if (!isValid) {
      return;
    }
    try {
      setIsLoading(true);
      const request: Record<string, any> = {};
      clinicianProfileFields.forEach((field) => {
        request[field.key] = userInfoFormData[field.key];
      });
      const result = await updateClinicianProfileContact({
        clinicianProfileDetails: request,
      });
      if (result.message === 'Success') {
        Swal.fire({
          icon: 'success',
          text: 'Your details have been updated',
        });
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'Failed to update your details',
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error('Failed to update clinician profile contact', error);
      Swal.fire({
        icon: 'warning',
        text: 'Failed to update your details',
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Form.Group as={Row} controlId="firstName" className="mb-4">
        <Col sm={12} md={7} xl={5}>
          <Form.Label>First Name*</Form.Label>
          <Form.Control
            name="firstName"
            type="text"
            disabled
            value={firstName}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="lastName" className="mb-4">
        <Col sm={12} md={7} xl={5}>
          <Form.Label>Last Name*</Form.Label>
          <Form.Control name="lastName" type="text" disabled value={lastName} />
        </Col>
      </Form.Group>

      {clinicianProfileFields.map((profileField, index) => (
        <Form.Group
          key={profileField.key + index}
          as={Row}
          controlId={profileField.key}
          className="mb-4"
        >
          <Col sm={12} md={7} xl={5}>
            <Form.Label>{profileField.title}</Form.Label>
            <Form.Control
              isInvalid={!!userInfoErrors[profileField.key]}
              name={profileField.key}
              value={userInfoFormData[profileField.key]}
              onChange={(e) => userInfoOnInputChange(e, profileField.type)}
            />
            {userInfoErrors[profileField.key] && (
              <Form.Control.Feedback type="invalid">
                <span className="roboto">
                  {userInfoErrors[profileField.key]}
                </span>
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ))}

      <Form.Group as={Row} controlId="" className="mb-4">
        <Col sm={12} md={7} xl={5}>
          <CareMapprButton
            isLoading={isLoading}
            type="submit"
            className="btn btnPrimary btn-long btn-sm"
          >
            Update
          </CareMapprButton>
        </Col>
      </Form.Group>
    </form>
  );
};

export default UserInfo;
